import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import { addErrorNotification } from './notificationsSlice';

const initialState = {
  imgSrc: '',
  certificatesInfo: [],
};

// ---------------------- ASYNC THUNKS ----------------------

export const verifyCert = createAsyncThunk(
  'corporateVerifierHome/verifyCert',
  async ({ certificateId }, thunkAPI) => {
    const res = await requests.verifyCert(certificateId);
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || 'Something Went Wrong When Fetching The Certificate!'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

export const searchUserCertificates = createAsyncThunk(
  'corporateVerifierHome/searchUserCertificates',
  async (email, thunkAPI) => {
    const res = await requests.searchUserCertificates(email);
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg || "Something Went Wrong When Fetching The User's Certificates!"
        )
      );
    }

    return { ok: res.ok, body };
  }
);

// ---------------------- SLICE ----------------------

export const corporateVerifierHomeSlice = createSlice({
  name: 'corporateVerifierHome',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(verifyCert.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          const certificateBase64 = payload.body.certificate;
          const blob = new Blob([Buffer.from(certificateBase64, 'base64')]);
          state.imgSrc = URL.createObjectURL(blob);
        }
      })
      .addCase(searchUserCertificates.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          state.certificatesInfo = [...payload.body.certificates];
        }
      });
  },
});

export default corporateVerifierHomeSlice.reducer;
